import React, { useContext, useEffect } from 'react'

import { WithFullpage } from '../../app/providers/WithFullpage'
import { MainContext } from '../../app/providers/MainContext'
import { GitbookScreens } from '../../widgets/Screens/Gitbook'

export const Gitbook = () => {
  const { setCurrentPage } = useContext(MainContext)

  useEffect(() => {
    setCurrentPage('gitbook')
  }, [])

  return (
    <>
      <WithFullpage
        fullpageOptions={{
          credits: {
            enabled: false,
          },
          scrollingSpeed: 1000,
          touchSensitivity: 10,
        }}
      >
        <>
          {GitbookScreens.map((screen, idx) => (
            <React.Fragment key={idx}>{screen}</React.Fragment>
          ))}
        </>
      </WithFullpage>
    </>
  )
}
